export type EventTypeString = 'MQ_CHANGED';

export const eventType: EventTypeString = 'MQ_CHANGED';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
